 
<div class="container-fluid">
 <div class="row">
   <div class="col-sm-12">
     <div class="card">
       <div class="card-header" style="padding-bottom: 5px !important">
         <div  class="row">

           <div class="col-lg-6 col-sm-12">



           <h5 class="pb-2">القائمة المهنية الرئيسية </h5>
        
           
             
           </div>



           <div class="col-6 header-titles">
             <a routerLink="/content/admin/insert-Job" class="d-block">
               <button class="btn pull-right" type="button">
                 <span class="m-2">إضافة جديدة</span>
                 <i class="fa fa-plus"></i>
               </button>
             </a>
           </div>
 
         </div>
      
       
       </div>
      
       <div class="card-block row">
         <div class="col-sm-12 col-lg-12 col-xl-12">
           <div class="table-responsive">
             <table class="table table-responsive-sm">
               <thead>
                 <tr class=" ">
                   <th scope="col"></th>
                   <th scope="col" style="width: 10%;">اسم الوظيفه</th>
                   <th scope="col">وصف الوظيفه</th>
                   <th scope="col">الحالة</th>

                   <th scope="col"></th>
                 </tr>
               </thead>
               <tbody>
                 <tr
                   *ngFor="let item of response; let i = index; trackBy: track"
                   class=" "
                 >
                   <td scope="row">{{ i + 1 }}</td>
                   <td>{{ item.title }}</td>
                   <td>{{ item.description }}</td>
                   <td>
                    <span *ngIf="!item.inactive">نشط</span>
                    <span *ngIf="item.inactive">غير نشط</span>
                  </td>
                      <td class="font-style chose">
                     <button
                       class="btn pull-right"
                       (click)="Delete(item.id)"
                       style="color: red; padding: 7px"
                     >
                       <i class="fa fa-trash"></i>
                     </button>        <button
                       class="btn pull-right"
                       style="color: rgba(35, 118, 241, 0.667); padding: 7px"
                       (click)="Update(item.id)"
                     >
                       <i class="fa fa-pencil"></i>
                     </button>
                   </td>
                 </tr>
               </tbody>
             </table>
             <div class="row justify-content-center w-100">
               <!-- <div class='d-flex justify-content-center w-50 py-3'>
                 <ngb-pagination class="my-3" [collectionSize]="totalCount" [(page)]="pageNumber" [maxSize]="5"
                 (pageChange)="pageChanged($event)" [boundaryLinks]="true"></ngb-pagination>
                 
               </div> -->

               <div class="d-flex justify-content-center">
                <pagination [boundaryLinks]="true" [maxSize]="5" [totalItems]="totalCount"
                    previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"
                    [itemsPerPage]="pager.maxResultCount" [(ngModel)]="pageNumber"
                    (pageChanged)="pageChanged($event)">
                </pagination>
            </div>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
 </div>
</div>
